import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import store from "../../../../../redux/store";
import adminController from "../../../../../apis/Controllers/AdminControler/admin.controller";

const StaffDetailFunctions = () => {
    var breadcrumData = ["Dashboard", "Staff List"];
    const [breadcrumItem, setbreadcrumItem] = useState("");
    const [loader, setLoader] = useState(false);
    const [staffDetail, setStaffDetail] = useState(null);
    const loaction = useLocation();
    const navigate = useNavigate();


    const getStaffDetails = async (id) => {
        setLoader(true);
        let response = await adminController.adminDetail(id);
        if (response && response.status) {
            setStaffDetail(response.data);
            setLoader(false);
        } else {
            setStaffDetail(null);
            setLoader(false);
        }
    };


    const handleBreadcrumDataNaviagtion = (i) => {
        let user = store.getState().UserReducer.user;
        if (i === 0) {
            if (user && parseInt(user.user_type) === 2) {
                navigate("/dashboard");
            } else {
                navigate("/dashboard-superadmin");
            }
        } else if (i === 1) {
            navigate("/staff-list");
        } else return;
    };


    return {
        loader,
        breadcrumItem,
        setbreadcrumItem,
        breadcrumData,
        loaction,
        navigate,
        getStaffDetails,
        staffDetail,
        handleBreadcrumDataNaviagtion,
    };
};

export default StaffDetailFunctions;
